import { FC } from 'react';
import { PaginationItem, Stack, Theme } from '@mui/material';
import {
  gridPageSizeSelector,
  gridRowCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import Button from '@/components/button';
import { PaginationProps } from '../helpers';

const useStyles = createUseStyles((theme: Theme) => ({
  action: {
    '& .MuiPaginationItem-root.Mui-selected': {},
  },
  liveButton: {
    height: 24,
    width: 66,
    margin: 0,
    fontSize: theme.typography.caption.fontSize,
    minHeight: '0 !important',

    '& svg': {
      height: 16,
      width: 16,
      marginRight: -8,
    },
  },
}));

const PaginationAction: FC<PaginationProps> = ({
  page,
  onPageChange,
  className = '',
  isCursorMode,
  enablePolling,
  onPollingChange,
}) => {
  const styles = useStyles();
  const apiRef = useGridApiContext();
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const compClass = classNames(className, styles.action);

  return (
    <Stack direction="row" alignItems="center" className={className}>
      {isCursorMode && (
        <Button
          onClick={onPollingChange}
          icon={enablePolling ? 'live' : 'first-page'}
          label="Live"
          className={styles.liveButton}
          type={enablePolling ? 'submit' : 'option'}
          size="small"
        />
      )}
      <MuiPagination
        color="standard"
        className={compClass}
        count={Math.ceil(rowCount / pageSize)}
        page={page + 1}
        onChange={(_event, newPage) => {
          onPageChange(null, newPage - 1);
        }}
        renderItem={(item) => {
          const { type, selected } = item;
          if (
            !isCursorMode ||
            ['next', 'previous'].includes(type) ||
            (type === 'page' && selected)
          ) {
            return <PaginationItem {...item} />;
          }

          return null;
        }}
      />
    </Stack>
  );
};

export default PaginationAction;
